module.exports = __webpack_public_path__ + "img/template4.d9a52cb4.png";